import { useCallback, useEffect, useMemo, useState } from 'react';
// Estilização
import { toast } from 'react-toastify';
import { Card, Container, Page } from './styles';

// fucoes
import { differenceInDays } from 'date-fns';
import { listetapas } from '../../../config';

import Tooltip from '@material-ui/core/Tooltip';

// icones
import { Badge } from '@material-ui/core';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import NotesIcon from '@material-ui/icons/Notes';
import PersonIcon from '@material-ui/icons/Person';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import StopIcon from '@material-ui/icons/Stop';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { BsSortAlphaDown, BsSortAlphaUpAlt } from 'react-icons/bs';

// Chamadas da API
import { AccessTime } from '@material-ui/icons';
import { mask } from 'remask';
import SimpleBackdrop from '../../../components/Backdrop';
import { Pagination } from '../../../components/Pagination';
import { useAuth } from '../../../contexts/AuthContext';
import { GET_PROJECTS } from '../../../services/endpoints';
import { projects } from '../../../utils/constants';

import {
  DELETE_RESPONSIBLES,
  GET_RESPONSIBLES,
  PATCH_FINISHED_PROJECT,
  PATCH_PROJECTS_BY_ID,
  SET_CANCEL_PAYMENT_ID,
  SET_PAYMENT_ID,
} from '../../../services/endpoints';

import BaseDialogEditProject from '../../../components/BaseDialogEditProject';
import BaseDialogShowProject from '../../../components/BaseDialogShowProject';
import Chatbox from '../../../components/Chatbox';
import Dialogoadicionarsupervisor from '../../../components/Dialogoadicionarsupervisor';
import Dialogoconfirmacao from '../../../components/Dialogoconfirmacao';
import Dialogoverificaralteracao from '../../../components/Dialogoverificaralteracao';

const projectStatus = {
  paid: 'paid',
  waitingPayment: 'waiting_payment',
  refused: 'refused',
  none: 'none',
};

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

function NovosProjetos() {
  const { user } = useAuth();
  const [projetistas, setProjetistas] = useState([]);
  const [status, setStatus] = useState(false);
  const isAdmin = user?.role === 'ADMINISTRADOR' || user?.role === 'GERENTE';

  const [listProjects, setListProjects] = useState({});

  const [showbackdrop, setShowbackdrop] = useState(false);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(10);
  const [abaSelected, setAbaSelected] = useState(1);

  const sortByCreatedAsc = (a, b) =>
    new Date(a.created_at) - new Date(b.created_at);
  const getLastReceipt = (proj) =>
    (proj?.receipts || []).length
      ? [...proj.receipts].sort(sortByCreatedAsc)[0]
      : null;

  // Dialogo de suspensão - confirmação
  const [showconf, setShowconf] = useState({
    id: null,
    status: false,
    width: 'sm',
    title: 'Confirmar',
    description: 'Deseja realmente suspender este projeto?',
    btn_conf: 'Sim',
    btn_cancel: 'Não',
    delete: true,
    dados: '',
  });

  //Dialogo desvincular supervisor
  const [showconfdesvincular, setShowconfdesvincular] = useState({
    status: false,
    width: 'sm',
    title: 'Confirmar',
    description: 'Deseja realmente desvincular este supervisor?',
    btn_conf: 'Sim',
    btn_cancel: 'Não',
    delete: true,
    dados: '',
  });

  // Solicitar Mudança
  const [solicitarmud, setSolicitarmud] = useState({
    status: false,
    dados: '',
  });

  const [editProject, setEditProject] = useState({
    status: false,
    dados: '',
  });

  // Variável de edição
  const [viewedit, setViewedit] = useState({
    status: false,
    dados: '',
    dados_proj: '',
  });

  // Variável de visualizar projeto
  const [viewproject, setViewproject] = useState({
    status: false,
    dados: '',
  });

  // Modal de cadastro de Supervisor
  const [viewcadastrarsupervisor, setViewcadastrarsupervisor] = useState({
    status: false,
    dados: '',
  });

  const [filterMyProjects, setFilterMyProjects] = useState(false);

  const [filter, setFilter] = useState({
    type: '',
    value: '',
    dig: '',
  });

  const debouncedFilterValue = useDebounce(filter.value, 500);

  const [order, setOrder] = useState('');

  console.log(viewproject.dados, 'viewproject.dados');

  // ordem cronológica
  const maisatual = (a, b) => {
    return new Date(b.created_at) - new Date(a.created_at);
  };

  const sendWhatsapp = (phone) => {
    const clearedPhone = phone.replace(/\D/g, '');
    const url = `https://wa.me/${clearedPhone}`;

    window.open(url, '_blank');
  };

  useEffect(() => {
    if (user?.role === 'GERENTE') {
      setStatus(projectStatus.paid);
    } else {
      setStatus(false);
    }
  }, [user]);

  useEffect(() => {
    if (filter.type === 'projetista') {
      GET_RESPONSIBLES((data) => {
        setProjetistas(Array.isArray(data) ? data : []);
      });
    }
  }, [filter.type]);

  function statusProgress(value) {
    switch (value) {
      case listetapas[0]:
        return ((1 * 100) / 6).toFixed(2);
      case listetapas[1]:
        return ((2 * 100) / 6).toFixed(2);
      case listetapas[2]:
        return ((3 * 100) / 6).toFixed(2);
      case listetapas[3]:
        return ((4 * 100) / 6).toFixed(2);
      case listetapas[4]:
        return ((5 * 100) / 6).toFixed(2);
      case listetapas[5]:
        return ((6 * 100) / 6).toFixed(2);

      default:
        return 0;
    }
  }

  const handleChangeRow = useCallback((event) => {
    setPage(0);
    setRows(parseInt(event.target.value, 10));
  }, []);

  const handleChangePage = useCallback((_, newPage) => {
    setPage(newPage);
  }, []);

  const handleFilter = (dado) => {
    if (!filter.type) return true;
    if (filter.type === 'projetista' && !filter.value) return false;
    if (!filter.value) return true;

    switch (filter.type) {
      case 'name':
        return (
          !!dado.client_name &&
          dado.client_name.toLowerCase().includes(filter.value.toLowerCase())
        );
      case 'cpf':
        return (
          !!dado.client_cpf &&
          dado.client_cpf
            .replace(/[^0-9]/g, '')
            .includes(filter.value.replace(/[^0-9]/g, ''))
        );
      case 'cnpj':
        return (
          !!dado.client_cnpj &&
          dado.client_cnpj
            .replace(/[^0-9]/g, '')
            .includes(filter.value.replace(/[^0-9]/g, ''))
        );
      case 'project_type':
        return !!dado.type && dado.type === filter.value;
      case 'integrator':
        return (
          !!dado.integrators.length &&
          dado.integrators[0]?.integrator.name
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        );
      case 'projetista':
        if (filter.value === false || filter.value === 'false') {
          return (
            !Array.isArray(dado.responsibles) || dado.responsibles.length === 0
          );
        }
        if (!filter.value) return false;
        return (
          Array.isArray(dado.responsibles) &&
          dado.responsibles.some(
            (r) => String(r.user?.id) === String(filter.value)
          )
        );
      default:
        return true;
    }
  };

  const handleFilterValue = useCallback(
    (event) => {
      if (filter.type === 'cpf') {
        setFilter({
          ...filter,
          value: mask(event.target.value, '999.999.999-99'),
        });
      } else if (filter.type === 'cnpj') {
        setFilter({
          ...filter,
          value: mask(event.target.value, '99.999.999/9999-99'),
        });
      } else {
        setFilter({ ...filter, value: event.target.value });
      }
    },
    [filter]
  );

  const handleProjectPixUpdated = (projectId, newCode) => {
    setListProjects((prev) => {
      if (!prev || !Array.isArray(prev.data)) {
        return prev;
      }

      const updatedData = prev?.data?.map((p) =>
        p.id === projectId ? { ...p, pix_code: newCode } : p
      );

      return { ...prev, data: updatedData };
    });
  };

  const handleProjectPaymentUpdated = (projectId, receiptId, isPaid) => {
    setListProjects((prev) => {
      if (!prev || !Array.isArray(prev.data)) {
        return prev;
      }

      const updatedData = prev?.data?.map((p) =>
        p.id === projectId
          ? {
              ...p,
              receipts: (p.receipts || []).map((r) =>
                r.id === receiptId ? { ...r, is_paid: isPaid } : r
              ),
            }
          : p
      );

      let finalData = updatedData;

      if (status === projectStatus.paid && !isPaid) {
        finalData = updatedData.filter((p) => p.id !== projectId);
      }

      if (status === projectStatus.waitingPayment && isPaid) {
        finalData = updatedData.filter((p) => p.id !== projectId);
      }

      return {
        ...prev,
        data: finalData,
      };
    });
  };

  const filteredProjects = useMemo(() => {
    const base = Array.isArray(listProjects?.data) ? listProjects?.data : [];

    const ordered = [...base].sort((a, b) => {
      if (order === 'AZ') {
        return (a.client_name || '').localeCompare(b.client_name || '');
      } else if (order === 'ZA') {
        return (b.client_name || '').localeCompare(a.client_name || '');
      } else if (order === 'primeiros') {
        return new Date(b.created_at) - new Date(a.created_at);
      } else if (order === 'ultimos') {
        return new Date(a.created_at) - new Date(b.created_at);
      }
      return 0;
    });

    return ordered.filter(handleFilter);
  }, [listProjects, filter, order, user]);

  const getProjects = useCallback(async () => {
    let params = {
      status,
      hasDeadline: status === projectStatus.waitingPayment ? false : undefined,
      hasStages: status === projectStatus.waitingPayment ? false : undefined,
      hasResponsibles:
        status === projectStatus.waitingPayment ? false : undefined,
      page,
      rows,
      myProjects: filterMyProjects,
      dateOrder: 'DESC',
      is_approved: user?.role === 'ADMINISTRADOR' ? true : false,
    };

    if (filter.type && filter.value) {
      switch (filter.type) {
        case 'name':
          params.clientName = filter.value;
          break;
        case 'cpf':
          params.clientCpf = filter.value.replace(/[^0-9]/g, '');
          break;
        case 'cnpj':
          params.clientCnpj = filter.value;
          break;
        case 'integrator':
          params.integratorName = filter.value;
          break;
        case 'project_type':
          params.projectType = filter.value;
          break;
      }
    }

    if (filter.type === 'projetista' && filter.value) {
      params.responsible_id = filter.value;
    }

    await GET_PROJECTS(setListProjects, setShowbackdrop, params);
  }, [
    status,
    page,
    rows,
    filterMyProjects,
    debouncedFilterValue,
    filter.type,
    filter.value,
  ]);

  useEffect(() => {
    let params = {
      status,
      hasDeadline: status === projectStatus.waitingPayment ? false : undefined,
      hasStages: status === projectStatus.waitingPayment ? false : undefined,
      hasResponsibles:
        status === projectStatus.waitingPayment ? false : undefined,
      page,
      rows,
      myProjects: filterMyProjects,
      dateOrder: 'DESC',
      is_approved: user?.role === 'ADMINISTRADOR' ? true : false,
    };

    if (filter.type && debouncedFilterValue) {
      switch (filter.type) {
        case 'name':
          params.clientName = debouncedFilterValue;
          break;
        case 'cpf':
          params.clientCpf = debouncedFilterValue;
          break;
        case 'cnpj':
          params.clientCnpj = debouncedFilterValue;
          break;
        case 'integrator':
          params.integratorName = debouncedFilterValue;
          break;
        case 'project_type':
          params.projectType = debouncedFilterValue;
          break;
      }
    }

    if (filter.type === 'projetista' && debouncedFilterValue) {
      params.responsible_id = debouncedFilterValue;
    }

    GET_PROJECTS(setListProjects, setShowbackdrop, params);
  }, [
    abaSelected,
    filterMyProjects,
    status,
    page,
    rows,
    user?.role,
    filter.type,
    debouncedFilterValue,
  ]);

  return (
    <Container>
      <Page>
        <header>
          <h1>Projetos</h1>
          <span>
            Confira os novos projetos, analise, visualize, aceite e delegue um
            responsável.
          </span>
        </header>
        <content>
          {user?.role === 'ADMINISTRADOR' && (
            <div className="div__options__project">
              <button
                className={
                  filterMyProjects
                    ? 'button_project btn__aba_selected'
                    : 'button_project'
                }
                onClick={() => {
                  setPage(0);
                  setFilterMyProjects((prev) => !prev);
                }}
              >
                <AssignmentOutlinedIcon /> Meus Projetos
              </button>
            </div>
          )}
          {user?.role === 'GERENTE' && (
            <>
              <div className="div__options__project">
                <Badge
                  overlap="circular"
                  badgeContent={
                    status === projectStatus.paid &&
                    listProjects && Object.keys(listProjects).length !== 0
                      ? listProjects?.total
                      : undefined
                  }
                  style={{ marginTop: '-0.4rem' }}
                  color="secondary"
                >
                  <button
                    className={
                      abaSelected === 1
                        ? 'button_project btn__aba_selected'
                        : 'button_project'
                    }
                    onClick={() => {
                      setPage(0);
                      setStatus(projectStatus.paid);
                      setAbaSelected(1);
                    }}
                  >
                    <AssignmentOutlinedIcon /> Projetos Pagos
                  </button>
                </Badge>
                <Badge
                  overlap="circular"
                  badgeContent={
                    status === projectStatus.waitingPayment &&
                    listProjects &&Object.keys(listProjects).length !== 0
                      ? listProjects?.total
                      : undefined
                  }
                  style={{ marginTop: '-0.4rem' }}
                  color="secondary"
                >
                  <button
                    className={
                      abaSelected === 2
                        ? 'button_project btn__aba_selected'
                        : 'button_project'
                    }
                    onClick={() => {
                      setPage(0);
                      setStatus(projectStatus.waitingPayment);
                      setAbaSelected(2);
                    }}
                  >
                    <AccessTime /> Aguardando Pagamento
                  </button>
                </Badge>
                <Badge
                  overlap="circular"
                  badgeContent={
                    status === projectStatus.refused &&
                    listProjects && Object.keys(listProjects).length !== 0
                      ? listProjects.total
                      : undefined
                  }
                  style={{ marginTop: '-0.4rem' }}
                  color="secondary"
                >
                  <button
                    className={
                      abaSelected === 3
                        ? 'button_project btn__aba_selected'
                        : 'button_project'
                    }
                    onClick={() => {
                      setPage(0);
                      setStatus(projectStatus.refused);
                      setAbaSelected(3);
                    }}
                  >
                    <HighlightOffIcon /> Projetos Recusados
                  </button>
                </Badge>
              </div>
              <p className="p__subtitle_aba_selected">
                {abaSelected === 1
                  ? `Lista de todos os projetos pagos aguardando aprovação.`
                  : abaSelected === 2
                  ? 'Lista de todos os projetos lançados na plataforma aguardando pagamento.'
                  : 'Lista de projetos recusados (pagos e não pagos).'}
              </p>
            </>
          )}
          <div className="div__fieldFilter">
            <div className="div__filters">
              <select
                onChange={(event) =>
                  setFilter({
                    ...filter,
                    type: event.target.value,
                    value: '',
                    dig: '',
                  })
                }
                value={filter.type}
                style={{ maxWidth: 200 }}
              >
                <option value="" selected>
                  Filtro
                </option>
                <option value="-" disabled>
                  Opções
                </option>
                <option value="name">Cliente</option>
                <option value="cpf">CPF</option>
                <option value="cnpj">CNPJ</option>
                <option value="project_type">Tipo</option>
                <option value="integrator">Integrador</option>
                <option value="projetista">Projetista</option>
                {/* <option value="state">Estado</option> */}
                {/* <option value="concessionaria">Concessionária</option> */}
                {/* <option value="open_projects">Projetos em aberto</option> */}
                {/* <option value="delayed_projects">Projetos atrasados</option> */}
                {/* <option value="completed_projects">Projetos finalizados</option>
                <option value="suspended_projects">Projetos suspensos</option> */}
              </select>
              <input
                placeholder={
                  filter.type === 'name'
                    ? 'Digite o nome'
                    : filter.type === 'email'
                    ? 'Digite o E-mail'
                    : filter.type === 'cpf'
                    ? 'Digite o CPF'
                    : filter.type === 'cnpj'
                    ? 'Digite o CNPJ'
                    : filter.type === 'integrator'
                    ? 'Digite o nome do integrador'
                    : ' - '
                }
                value={filter.value}
                disabled={!filter.type}
                onChange={handleFilterValue}
                style={{
                  display:
                    filter.type === 'name' ||
                    filter.type === 'email' ||
                    filter.type === 'cpf' ||
                    filter.type === 'cnpj' ||
                    filter.type === 'integrator'
                      ? 'block'
                      : 'none',
                }}
              />
              <select
                required
                name="state"
                style={{
                  display: filter.type === 'state' ? 'block' : 'none',
                }}
                value={filter.value}
                onChange={handleFilterValue}
              >
                <option value="" disabled selected>
                  Escolha o estado
                </option>
                <option value="AC">AC</option>
                <option value="AL">AL</option>
                <option value="AP">AP</option>
                <option value="AM">AM</option>
                <option value="BA">BA</option>
                <option value="CE">CE</option>
                <option value="DF">DF</option>
                <option value="ES">ES</option>
                <option value="GO">GO</option>
                <option value="MA">MA</option>
                <option value="MT">MT</option>
                <option value="MS">MS</option>
                <option value="MG">MG</option>
                <option value="PA">PA</option>
                <option value="PB">PB</option>
                <option value="PR">PR</option>
                <option value="PE">PE</option>
                <option value="PI">PI</option>
                <option value="RJ">RJ</option>
                <option value="RN">RN</option>
                <option value="RS">RS</option>
                <option value="RO">RO</option>
                <option value="RR">RR</option>
                <option value="RC">SC</option>
                <option value="SP">SP</option>
                <option value="SE">SE</option>
                <option value="TO">TO</option>
              </select>
              {filter.type === 'project_type' && (
                <select
                  className="input-custom-style"
                  name="project_type"
                  value={filter.value}
                  onChange={handleFilterValue}
                >
                  <option value="" disabled selected>
                    Escolha o tipo
                  </option>

                  {Object.entries(projects).map(([key, value]) => {
                    return (
                      <option key={key} value={key}>
                        {value}
                      </option>
                    );
                  })}
                </select>
              )}
              {filter.type === 'projetista' && (
                <select
                  className="input-custom-style"
                  name="projetista"
                  value={filter.value}
                  onChange={handleFilterValue}
                >
                  <option value="" disabled selected>
                    Escolha o projetista
                  </option>
                  <option value={false}>Projetos sem responsável</option>
                  {projetistas.map((proj) => (
                    <>
                      <option key={proj.id} value={proj.id}>
                        {proj.name || proj.nome || proj.email}
                      </option>
                    </>
                  ))}
                </select>
              )}
            </div>
            <div className="div__order">
              <button
                className={order === 'AZ' ? 'btn__esq btn__ativ' : 'btn__esq'}
                onClick={() => {
                  order === 'AZ' ? setOrder('') : setOrder('AZ');
                }}
              >
                <BsSortAlphaDown style={{ fontSize: '1.4rem' }} />
              </button>
              <button
                className={order === 'ZA' ? 'btn_meio btn__ativ' : 'btn_meio'}
                onClick={() => {
                  order === 'ZA' ? setOrder('') : setOrder('ZA');
                }}
              >
                <BsSortAlphaUpAlt style={{ fontSize: '1.4rem' }} />
              </button>

              <button
                className={
                  order === 'primeiros' ? 'btn_meio btn__ativ' : 'btn_meio'
                }
                onClick={() => {
                  order === 'primeiros' ? setOrder('') : setOrder('primeiros');
                }}
              >
                Recentes
              </button>
              <button
                className={
                  order === 'ultimos' ? 'btn__dir btn__ativ' : 'btn__dir'
                }
                onClick={() => {
                  order === 'ultimos' ? setOrder('') : setOrder('ultimos');
                }}
              >
                Antigos
              </button>
            </div>
          </div>

          <div className="div__deck">
            {filteredProjects?.length > 0 &&
              filteredProjects.map((proj, idx) => (
                <Card
                  key={proj?.id}
                  progress={differenceInDays(
                    new Date(),
                    new Date(proj?.stages.sort(maisatual)[0]?.created_at)
                  )}
                  projetct_process={statusProgress(
                    proj?.stages?.sort(maisatual)[0]?.title
                  )}
                  max_process={differenceInDays(
                    new Date(proj?.stages.sort(maisatual)[0]?.deadline),
                    new Date(proj?.stages.sort(maisatual)[0]?.created_at)
                  )}
                  suspended={proj?.suspended}
                  finished={proj?.finished_at ? true : false}
                >
                  <div className="div__name">
                    {!proj.refused ? (
                      !proj.finished_at ? (
                        proj.suspended ? (
                          <span
                            style={{
                              textAlign: 'left',
                              color: 'gray',
                              marginBottom: '0.5rem',
                            }}
                          >
                            Projeto suspenso
                          </span>
                        ) : (
                          <span
                            style={{
                              textAlign: 'left',
                              color: 'var(--primary2)',
                              marginBottom: '0.5rem',
                            }}
                          >
                            Projeto em aberto
                          </span>
                        )
                      ) : (
                        <span
                          style={{
                            textAlign: 'left',
                            color: 'gray',
                            marginBottom: '0.5rem',
                          }}
                        >
                          {proj?.stages.sort(maisatual)[0]?.title ===
                          '5 - Projeto aprovado'
                            ? 'Projeto aprovado'
                            : proj?.stages.sort(maisatual)[0]?.title ===
                              '7 - Projeto reprovado'
                            ? 'Projeto reprovado'
                            : 'Projeto finalizado'}
                        </span>
                      )
                    ) : (
                      <span
                        style={{
                          textAlign: 'left',
                          color: 'var(--delete)',
                          marginBottom: '0.5rem',
                        }}
                      >
                        Projeto recusado
                      </span>
                    )}

                    <span className="tag-whatsapp">
                      {proj?.receipts[0]?.is_whatsapp && (
                        <p>Negociação pelo Whatsapp</p>
                      )}
                    </span>

                    <span className="tag">
                      {proj?.responsibles.length !== 0 ? (
                        <>
                          <p>
                            {proj?.responsibles
                              .sort(maisatual)[0]
                              ?.user?.name.split(' ')
                              .map((item, idx) => idx < 2 && item + ' ')}{' '}
                            -{' '}
                            {proj?.responsibles.sort(maisatual)[0]?.user?.role}
                          </p>
                          {!proj?.finished_at && isAdmin && (
                            <Tooltip
                              placement="bottom-start"
                              title="Remover supervisor"
                            >
                              <HighlightOffIcon
                                style={{
                                  color: 'var(--delete)',
                                  cursor: 'pointer',
                                }}
                                onClick={() =>
                                  setShowconfdesvincular({
                                    ...showconf,
                                    status: true,
                                    width: 'sm',
                                    title: 'Confirmar',
                                    description: `Deseja realmente desvincular o supervisor ${
                                      proj?.responsibles.sort(maisatual)[0]
                                        ?.user?.name
                                    } do projeto ${proj.client_name}?`,
                                    btn_conf: 'Sim',
                                    btn_cancel: 'Não',
                                    delete: false,
                                    dados: proj,
                                    type: 'DELETE_RESPONSIBLES',
                                  })
                                }
                              />
                            </Tooltip>
                          )}
                        </>
                      ) : (
                        <p
                          style={{
                            backgroundColor: 'var(--gray)',
                            color: 'var(--primary)',
                            cursor: 'pointer',
                          }}
                          onClick={() =>
                            setViewcadastrarsupervisor({
                              status: true,
                              dados: proj,
                            })
                          }
                        >
                          Adicionar Supervisor
                        </p>
                      )}
                    </span>

                    <h4>
                      <PersonIcon /> {proj?.client_name}
                    </h4>
                    {proj?.client_cpf && <span>CPF: {proj?.client_cpf}</span>}
                    {proj?.client_cnpj && (
                      <span>CNPJ: {proj?.client_cnpj}</span>
                    )}
                    <span>
                      {proj?.dealer?.name} - {proj?.dealer?.state}
                    </span>
                    {proj?.integrators && proj?.integrators.length > 0 && (
                      <span>
                        Integrador: {proj?.integrators[0]?.integrator?.name}
                      </span>
                    )}
                    <span>Tipo: {projects[proj.type]}</span>

                    <div className="div__options">
                      {!proj.refused && !proj?.finished_at && (
                        <Tooltip
                          placement="bottom-start"
                          title="Confirmar edição"
                        >
                          <Badge
                            overlap="circular"
                            badgeContent={
                              proj?.change_requests?.filter(
                                (change) => change.resolved === false
                              ).length
                            }
                            // showZero
                            style={{ marginTop: '-0.4rem' }}
                            color="secondary"
                          >
                            <button
                              onClick={() =>
                                setViewedit({
                                  status: true,
                                  dados: proj.change_requests,
                                  dados_proj: proj,
                                })
                              }
                            >
                              <AssignmentTurnedInIcon />
                            </button>
                          </Badge>
                        </Tooltip>
                      )}

                      {!proj.refused &&
                        !proj?.finished_at &&
                        !proj.suspended &&
                        proj?.stages?.length >= 1 && (
                          <Tooltip
                            placement="bottom-start"
                            title="Adicionar etapa ao projeto"
                          >
                            <button
                              onClick={() =>
                                setSolicitarmud({ status: true, dados: proj })
                              }
                            >
                              <NotesIcon />
                            </button>
                          </Tooltip>
                        )}

                      {!proj.refused && proj.stages?.length <= 0 && (
                        <Tooltip
                          placement="bottom-start"
                          title="Confirmar Recepção do projeto"
                        >
                          <button
                            onClick={() =>
                              setSolicitarmud({ status: true, dados: proj })
                            }
                          >
                            <PlaylistAddCheckIcon />
                          </button>
                        </Tooltip>
                      )}

                      <Tooltip placement="bottom-start" title="Editar projeto">
                        <button
                          onClick={() =>
                            setEditProject({ status: true, dados: proj })
                          }
                        >
                          <EditOutlinedIcon />
                        </button>
                      </Tooltip>

                      <Tooltip
                        placement="bottom-start"
                        title="Visualizar informações de projeto"
                      >
                        <Badge
                          overlap="circular"
                          badgeContent={
                            proj?.pendencies?.filter(
                              (change) =>
                                change.customer_comment &&
                                change.resolved === false
                            ).length
                          }
                          // showZero
                          style={{ marginTop: '-0.4rem' }}
                          color="secondary"
                        >
                          <button
                            onClick={() =>
                              setViewproject({ status: true, dados: proj })
                            }
                          >
                            <VisibilityOutlinedIcon />
                          </button>
                        </Badge>
                      </Tooltip>
                      {proj?.receipts[0]?.is_whatsapp && (
                        <Tooltip
                          placement="bottom-start"
                          title="Negociar pelo WhatsApp"
                        >
                          <button
                            className={
                              !proj?.integrators[0]?.integrator
                                ?.phone_numbers[0]?.is_whatsapp &&
                              'whatsappButton_disabled'
                            }
                            onClick={() => {
                              if (
                                proj?.integrators[0]?.integrator
                                  ?.phone_numbers[0]?.is_whatsapp
                              ) {
                                sendWhatsapp(
                                  proj?.integrators[0]?.integrator
                                    ?.phone_numbers[0]?.number
                                );

                                return;
                              }

                              toast.warn(
                                'O número que o integrador cadastrou não é WhatsApp. Entre em contato de outra maneira.'
                              );
                            }}
                          >
                            <WhatsAppIcon />
                          </button>
                        </Tooltip>
                      )}
                      {!proj?.finished_at && proj.suspended && (
                        <Tooltip
                          placeholder="bottom-start"
                          title="Retomar projeto"
                        >
                          <button
                            onClick={() =>
                              setShowconf({
                                ...showconf,
                                status: true,
                                width: 'sm',
                                title: 'Confirmar',
                                description: `Deseja realmente retomar o projeto de ${proj.client_name}?`,
                                btn_conf: 'Sim',
                                btn_cancel: 'Não',
                                delete: false,
                                dados: proj,
                                type: 'PATCH_PROJECTS_BY_ID',
                              })
                            }
                          >
                            <PlayArrowIcon />
                          </button>
                        </Tooltip>
                      )}
                      {!proj.refused &&
                        !proj?.finished_at &&
                        !proj.suspended && (
                          <Tooltip
                            placement="bottom-start"
                            title="Suspender projeto"
                          >
                            <button
                              className="button_delete"
                              onClick={() =>
                                setShowconf({
                                  ...showconf,
                                  status: true,
                                  width: 'sm',
                                  title: 'Confirmar',
                                  description: `Deseja realmente suspender o projeto de ${proj.client_name}?`,
                                  btn_conf: 'Sim',
                                  btn_cancel: 'Não',
                                  delete: false,
                                  dados: proj,
                                  type: 'PATCH_PROJECTS_BY_ID',
                                })
                              }
                            >
                              <StopIcon />
                            </button>
                          </Tooltip>
                        )}
                    </div>
                  </div>
                  <div className="div__total_project_power">
                    <h4>
                      {proj.total_project_power &&
                        `${proj.total_project_power}kWp`}
                    </h4>
                    <div className="div__sub_total_project_power">
                      <span>Início:</span>{' '}
                      <p style={{ margin: '0rem' }}>
                        {new Date(proj.created_at).toLocaleDateString('pt-BR')}
                      </p>
                    </div>
                    <div className="div__sub_total_project_power">
                      {!proj?.finished_at ? (
                        <span>Previsão de Conclusão:</span>
                      ) : (
                        <span>Finalizado em:</span>
                      )}{' '}
                      {!proj.suspended ? (
                        proj.stages?.length > 0 || proj.finished_at ? (
                          <p style={{ margin: '0rem' }}>
                            {new Date(
                              proj.finished_at
                                ? proj.finished_at
                                : proj.stages && proj.stages[0]?.deadline
                            ).toLocaleDateString('pt-BR')}
                          </p>
                        ) : (
                          <p>--/--/----</p>
                        )
                      ) : (
                        <p>--/--/----</p>
                      )}
                    </div>
                    <div className="div__options">
                      {!proj.refused && !proj?.suspended && (
                        <Tooltip
                          placement="bottom-start"
                          title={
                            !proj.finished_at
                              ? 'Finalizar projeto'
                              : 'Reativar projeto'
                          }
                        >
                          <button
                            className={
                              !proj.finished_at
                                ? 'button_project button_cancel_project'
                                : 'button_project'
                            }
                            onClick={() =>
                              !proj.finished_at
                                ? setShowconf({
                                    ...showconf,
                                    status: true,
                                    width: 'sm',
                                    title: 'Confirmar',
                                    description: `Deseja realmente finalizar o projeto de ${proj.client_name}?`,
                                    btn_conf: 'Sim',
                                    btn_cancel: 'Não',
                                    delete: true,
                                    dados: proj,
                                    type: 'SET_FINISH_PROJECT',
                                  })
                                : setShowconf({
                                    ...showconf,
                                    status: true,
                                    width: 'sm',
                                    title: 'Confirmar',
                                    description: `Deseja realmente reativar o projeto de ${proj.client_name}?`,
                                    btn_conf: 'Sim',
                                    btn_cancel: 'Não',
                                    delete: false,
                                    dados: proj,
                                    type: 'SET_OPEN_PROJECT',
                                  })
                            }
                          >
                            <AssignmentOutlinedIcon />{' '}
                            {!proj.finished_at ? 'Finalizar' : ' Reabrir'}
                          </button>
                        </Tooltip>
                      )}
                    </div>
                  </div>

                  <div className="div__status">
                    <div className="barra_progresso">
                      <span />{' '}
                      <div>
                        <h4>Status do Projeto</h4>
                      </div>
                    </div>
                    <div className="barra_progresso">
                      <span>
                        PROJETO (
                        {statusProgress(
                          proj?.stages?.sort(maisatual)[0]?.title
                        )}
                        %)
                      </span>
                      <div className="div__status_project" />
                    </div>

                    {proj.suspended ||
                    proj.finished_at ||
                    proj.stages.length === 0 ? (
                      <div className="barra_progresso">
                        <span style={{ marginTop: '1rem' }}>Situação</span>
                      </div>
                    ) : (
                      <div className="barra_progresso">
                        {proj?.stages && (
                          <span style={{ marginTop: '1rem' }}>
                            {proj?.stages.sort(maisatual)[0].title} <br />
                            (há{' '}
                            {differenceInDays(
                              new Date(),
                              new Date(
                                proj?.stages.sort(maisatual)[0]?.created_at
                              )
                            )}{' '}
                            dias)
                            <br />
                            Estimativa:{' '}
                            {differenceInDays(
                              new Date(
                                proj?.stages.sort(maisatual)[0]?.deadline
                              ),
                              new Date(
                                proj?.stages.sort(maisatual)[0]?.created_at
                              )
                            )}{' '}
                            dias
                            {}
                          </span>
                        )}
                        <div className="div__status_process" />
                      </div>
                    )}

                    <div className="barra_progresso">
                      <span />
                      {(() => {
                        const stages = Array.isArray(proj?.stages)
                          ? proj.stages
                          : [];

                        const latestStage = stages.length
                          ? [...stages].sort(maisatual)[0]
                          : undefined;

                        if (proj?.finished_at) {
                          if (latestStage?.title === '5 - Projeto aprovado') {
                            return (
                              <div className="div__description">
                                PROJETO APROVADO
                              </div>
                            );
                          }
                          if (latestStage?.title === '7 - Projeto reprovado') {
                            return (
                              <div className="div__description">
                                PROJETO REPROVADO
                              </div>
                            );
                          }
                          return (
                            <div className="div__description">
                              PROJETO FINALIZADO
                            </div>
                          );
                        }

                        if (proj?.suspended) {
                          return (
                            <div className="div__description">
                              PROJETO SUSPENSO
                            </div>
                          );
                        }

                        if (!proj.stages[0]?.deadline) {
                          return (
                            <div className="div__description">
                              PROJETO AGUARDANDO APROVAÇÃO DA CONCESSIONÁRIA
                            </div>
                          );
                        }

                        if (!stages.length) {
                          return (
                            <div className="div__description">
                              PROJETO AGUARDANDO APROVAÇÃO DA CONCESSIONÁRIA
                            </div>
                          );
                        }

                        const desc = latestStage?.description;

                        return (
                          <div className="div__description">
                            {desc ? `DESCRIÇÃO: ${desc}` : 'Sem descrição'}
                          </div>
                        );
                      })()}
                    </div>
                  </div>
                </Card>
              ))}
          </div>
        </content>

        {listProjects?.total > rows && filteredProjects?.length > 0 ? (
          <div className="div__viewMore">
            <Pagination
              page={page}
              rowsPerPage={rows}
              total={listProjects?.total}
              handleChangeRowsPerPage={handleChangeRow}
              handleChangePage={handleChangePage}
            />
          </div>
        ) : filteredProjects.length === 0 && filter.type ? (
          <div style={{ margin: '2rem 1rem', textAlign: 'center' }}>
            Nenhum projeto encontrado.
          </div>
        ) : filteredProjects.length === 0 && !filter.type ? (
          <div style={{ margin: '2rem 1rem', textAlign: 'center' }}>
            Nenhum projeto cadastrado.
          </div>
        ) : null}

        {/* {filteredProjects.length === 0 && (
          <div style={{ margin: '2rem 1rem', textAlign: 'center' }}>
            Nenhum integrador encontrado.
          </div>
        )} */}
      </Page>

      {showconf.status && (
        <Dialogoconfirmacao
          status={showconf.status}
          width={showconf.width}
          delete={showconf.delete}
          description={showconf.description}
          fechar={() =>
            setShowconf({
              status: false,
              width: 'sm',
              title: 'Confirmar',
              description: 'Deseja realmente suspender este projeto?',
              btn_conf: 'Sim',
              btn_cancel: 'Não',
              delete: true,
              dados: '',
            })
          }
          confirmar={() => {
            if (showconf.type === 'PATCH_PROJECTS_BY_ID') {
              if (showconf.dados.suspended) {
                PATCH_PROJECTS_BY_ID(
                  showconf.dados.id,
                  async () => {
                    await getProjects();
                  },
                  setShowbackdrop
                );
                toast.success(
                  `Projeto ${showconf.dados.client_name} retomado com sucesso`
                );
              } else {
                PATCH_PROJECTS_BY_ID(
                  showconf.dados.id,
                  async () => {
                    await getProjects();
                  },
                  setShowbackdrop
                );
                toast.info(
                  `Projeto de ${showconf.dados.client_name} suspenso com sucesso`
                );
              }
            } else if (showconf.type === 'SET_PAYMENT_ID') {
              const last = getLastReceipt(showconf.dados);
              const receiptId = last?.id;

              SET_PAYMENT_ID(receiptId, async () => {
                handleProjectPaymentUpdated(showconf.dados.id, receiptId, true);

                await getProjects();

                setShowconf({
                  status: false,
                  width: 'sm',
                  title: 'Confirmar',
                  description: 'Deseja realmente suspender este projeto?',
                  btn_conf: 'Sim',
                  btn_cancel: 'Não',
                  delete: true,
                  dados: '',
                });
              });
            } else if (showconf.type === 'SET_CANCEL_PAYMENT_ID') {
              const last = getLastReceipt(showconf.dados);
              const receiptId = last?.id;

              SET_CANCEL_PAYMENT_ID(receiptId, async () => {
                handleProjectPaymentUpdated(
                  showconf.dados.id,
                  receiptId,
                  false
                );

                await getProjects();

                setShowconf({
                  status: false,
                  width: 'sm',
                  title: 'Confirmar',
                  description: 'Deseja realmente suspender este projeto?',
                  btn_conf: 'Sim',
                  btn_cancel: 'Não',
                  delete: true,
                  dados: '',
                });
              });
            } else if (showconf.type === 'SET_FINISH_PROJECT') {
              PATCH_FINISHED_PROJECT(
                showconf.dados.id,
                { finished_at: new Date().toISOString() },
                async () => {
                  await getProjects();
                },
                setShowbackdrop
              );
              toast.success('Projeto finalizado com sucesso!');
              setShowconf({
                status: false,
                width: 'sm',
                title: 'Confirmar',
                description: 'Deseja realmente suspender este projeto?',
                btn_conf: 'Sim',
                btn_cancel: 'Não',
                delete: true,
                dados: '',
                type: '',
              });
            } else if (showconf.type === 'SET_OPEN_PROJECT') {
              PATCH_FINISHED_PROJECT(
                showconf.dados.id,
                { finished_at: null },
                async () => {
                  await getProjects();
                },
                setShowbackdrop
              );
              toast.success('Projeto reaberto com sucesso!');
              setShowconf({
                status: false,
                width: 'sm',
                title: 'Confirmar',
                description: 'Deseja realmente suspender este projeto?',
                btn_conf: 'Sim',
                btn_cancel: 'Não',
                delete: true,
                dados: '',
                type: '',
              });
            }
          }}
        />
      )}

      {showconfdesvincular.status && (
        <Dialogoconfirmacao
          status={showconfdesvincular.status}
          width={showconfdesvincular.width}
          delete={showconfdesvincular.delete}
          description={showconfdesvincular.description}
          fechar={() =>
            setShowconfdesvincular({
              status: false,
              width: 'sm',
              title: 'Confirmar',
              description: 'Deseja realmente suspender este projeto?',
              btn_conf: 'Sim',
              btn_cancel: 'Não',
              delete: true,
              dados: '',
              type: 'DELETE_RESPONSIBLES',
            })
          }
          confirmar={async () => {
            await DELETE_RESPONSIBLES(
              showconfdesvincular.dados.responsibles[0].id,
              async () => await getProjects(),
              setShowbackdrop
            );
          }}
        />
      )}

      {viewcadastrarsupervisor.status && (
        <Dialogoadicionarsupervisor
          dados={viewcadastrarsupervisor.dados}
          fechar={() =>
            setViewcadastrarsupervisor({ status: false, dados: '' })
          }
          atualizar={async () => {
            let params = {};

            params = {
              status,
              hasDeadline:
                status === projectStatus.waitingPayment ? false : undefined,
              hasStages:
                status === projectStatus.waitingPayment ? false : undefined,
              hasResponsibles:
                status === projectStatus.waitingPayment ? false : undefined,
              page,
              rows,
              myProjects: filterMyProjects,
              dateOrder: 'DESC',
              is_approved: user?.role === 'ADMINISTRADOR' ? true : false,
            };

            GET_PROJECTS(setListProjects, setShowbackdrop, params);
          }}
        />
      )}

      {viewedit.status && (
        <Dialogoverificaralteracao
          dados={viewedit.dados}
          dados_proj={viewedit.dados_proj}
          fechar={() =>
            setViewedit({ status: false, dados: '', dados_proj: '' })
          }
          edit={setViewproject}
          atualizar={async () => await getProjects()}
        />
      )}

      {editProject.status && (
        <BaseDialogEditProject
          dados={editProject.dados}
          fechar={() => setEditProject({ status: false, dados: '' })}
          atualizar={async () => await getProjects()}
          onProjectPixUpdated={handleProjectPixUpdated}
          onProjectPaymentUpdated={handleProjectPaymentUpdated}
        />
      )}

      {viewproject.status && (
        // <Dialogoverprojeto
        //   dados={viewproject.dados}
        //   dados_edit={viewproject?.dados_edit}
        //   fechar={() => setViewproject({ status: false, dados: '' })}
        //   atualizar={async () =>
        //     await getProjects()
        //   }
        //   onProjectPixUpdated={handleProjectPixUpdated}
        //   onProjectPaymentUpdated={handleProjectPaymentUpdated}
        // />
        <BaseDialogShowProject
          dados={viewproject.dados}
          dados_edit={viewproject?.dados_edit}
          fechar={() => setViewproject({ status: false, dados: '' })}
        />
      )}

      {solicitarmud.status && (
        <Chatbox
          fechar={() => setSolicitarmud({ status: false, dados: '' })}
          dados={solicitarmud.dados}
          disabledOptions={
            !solicitarmud.dados.refused &&
            solicitarmud.dados.stages?.length <= 0
          }
          atualizar={async () => await getProjects()}
        />
      )}

      {showbackdrop && <SimpleBackdrop />}
    </Container>
  );
}

export default NovosProjetos;
